import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-captcha-config-view',
  standalone: true,
  templateUrl: './captcha-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptchaConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
